import styled from "styled-components";
import { DEVICE_MAP } from "../utils";
export const Row = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.5rem;
  margin-left: -0.5rem;

  @media ${({ theme }) => theme.device.medium} {
    margin-right: -0.75rem;
    margin-left: -0.75rem;
  }

  ${({ reverse, theme }) => {
    if (!reverse)
        return `
      flex-direction: row;
      flex-wrap: wrap;
    `;
    if (typeof reverse === "object") {
        return Object.keys(reverse).map((responsiveSize) => `
        @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
          flex-direction: ${reverse[responsiveSize] ? "row-reverse" : "row"};
          flex-wrap: ${reverse[responsiveSize] ? "wrap-reverse" : "wrap"};
        }
      `);
    }
    return `
      flex-direction: row-reverse;
      flex-wrap: wrap-reverse;
    `;
}}

  ${({ align, theme }) => {
    if (!align)
        return "";
    if (typeof align === "object") {
        return Object.keys(align).map((responsiveSize) => `
        @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
          align-items: ${align[responsiveSize]};
        }
      `);
    }
    return `align-items: ${align};`;
}}

  ${({ justify, theme }) => {
    if (!justify)
        return "";
    if (typeof justify === "object") {
        return Object.keys(justify).map((responsiveSize) => `
        @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
          justify-content: ${justify[responsiveSize]};
        }
      `);
    }
    return `justify-content: ${justify};`;
}}
`;
